import React, { useEffect } from 'react'
import ReactGA from 'react-ga'

const Navbar = () => {
  useEffect(()=>{
    ReactGA.pageview(window.location.pathname)
  },[])
  const clickable =()=>{
    console.log('clicked')
    ReactGA.event({
      category:"subscribe",
      action:'click',
      label:'Subscribe Button Clicked',
      value :1,
    })
  }
  return (
   <header className="transition-all duration-300 text-gray-600 body-font shadow-sm md:shadow-md">
  <div className="container px-5 md:w-[80%] md:px-0 mx-auto flex flex-wrap p-5  md:flex-row items-center justify-between">
   
    
      <span className="ml-3  font-semibold text-2xl">CoderInsan</span>
   

    <button onClick={clickable} className="inline-flex items-center bg-black  border-0 py-2 px-5 focus:outline-none hover:bg-black  text-white rounded text-base mt-4 md:mt-0">Subscribe 
     
    </button>
  </div>
</header>

  )
}

export default Navbar
